import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-material-design-icon-themes',
	templateUrl:'./MaterialDesignIconThemesPluginCompPage.html',
	styles: [],
	styleUrls:['./MaterialDesignIconThemesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialDesignIconThemesPluginCompPage
{
	mdContent_1071 = `\`\`\`java
import com.jwebmp.plugins.materialdesignicons.MaterialDesignIconThemes;
\`\`\``;
}
